import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ConcernMessage.scss';
import { getContactInformation, FormattedMessage } from 'ui/i18n';

export default class ConcernMessage extends Component {
	static propTypes = {
		userCountry: PropTypes.string.isRequired,
	};

	render() {
		const { phoneNumber } = getContactInformation(this.props.userCountry, true);

		return (
			<p className="ConcernMessage">
				<FormattedMessage id="orderHistory.concernMessage" />
				{phoneNumber}.
			</p>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ConcernMessage/index.js